import { render, staticRenderFns } from "./SchoolLookupAds.vue?vue&type=template&id=723cd3fa&scoped=true&"
import script from "./SchoolLookupAds.vue?vue&type=script&lang=js&"
export * from "./SchoolLookupAds.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLookupAds.vue?vue&type=style&index=0&id=723cd3fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723cd3fa",
  null
  
)

export default component.exports